import { formatDate } from '../../utilities';
import { ContactState } from '../../templates';
import { contactColumn } from '../../templates';
import type { ColumnType } from '../../components';
import type { ItemType } from './useCampaignMonitoring';

type StandartColumnnsKeys =
  | 'contact_info'
  | 'latest_contact_state'
  | 'next_task_info';

type ResultType = {
  [x in StandartColumnnsKeys]: ColumnType<ItemType>;
};

export const getDefaultColumns = (
  id: string,
  statesMap: Record<any, any>
): ResultType => ({
  contact_info: contactColumn,
  latest_contact_state: {
    header: 'State',
    sortName: 'latest_contact_state',
    cellClassName: 'max-w-[15rem]',
    getValue: ({ campaign_id, campaign_name, latest_contact_state: state }) => (
      <ContactState
        className="max-w-[13rem]"
        campaignName={campaign_name}
        latest_contact_state={state}
        campaignId={campaign_id || id}
        latest_contact_state_label={!!state && statesMap[state]}
      />
    ),
  },
  next_task_info: {
    header: 'Next Task',
    sortName: 'next_task_time',
    cellClassName: 'text-small',
    getValue: ({ next_task_time, next_task_channel }) => (
      <div className="flex flex-col">
        <div>{next_task_channel}</div>
        <div className="text-tiny text-textLight">
          {formatDate(next_task_time)}
        </div>
      </div>
    ),
  },
});
